import React from 'react';
import { ModalContainer } from '../../components/ModalContainer';
import MvpAppBody from '../../components/MvpAppBody';
import { t } from 'i18next';

interface ICancelOrderNotification {
  title: string;
  footer?: JSX.Element;
  onConfirm?: () => void;
  onCancel?: () => void;
  message?: any;
}

export const MvpCanceledOrderModal = ({
  footer,
  title,
  onConfirm,
  onCancel,
  message = t('CanceledExpiredInMvpAppText'),
}: ICancelOrderNotification) => {
  return (
    <ModalContainer width={320}>
      <MvpAppBody
        isConfirmationDialog={true}
        onConfirm={onConfirm}
        onCancel={onCancel}
        title={title}
        footer={footer}
        contentMessage={message}
        isSuccessDialog={false}
      />
    </ModalContainer>
  );
};

export default MvpCanceledOrderModal;
